import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FlexBox, Typography, Button, Box, Card, color } from '@kis-technologies/kis-ui';
import { selectors as configSelectors, Configuration } from 'store/configurations';
import { LinkedContentDrawer } from './LinkedContentDrawer';
import { MediaText } from '../MediaText';
import { MediaTypes } from '../../../types';

interface LinkedContentProps {
  configuration: Configuration;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attractLoop: any;
  isActive: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateConfig: (payload: any) => void;
  onDelete: () => void;
}

export const LinkedContent: React.FC<LinkedContentProps> = (props: LinkedContentProps) => {
  const { isActive, attractLoop, configuration } = props;
  const loading = useSelector(configSelectors.selectPending);
  const [showDrawer, setShowDrawer] = useState(false);

  const onMakeActive = () => {
    props.updateConfig({ type: MediaTypes.LINKED_CONTENT });
  };

  return (
    <>
      <LinkedContentDrawer
        isOpen={showDrawer}
        configuration={configuration}
        attractLoop={attractLoop}
        onClose={() => setShowDrawer(false)}
      />
      {attractLoop && attractLoop.linkedContentUrl ? (
        <FlexBox fullWidth>
          <Box width={650}>
            <Card raised hasBorderRadius>
              <Card.Title
                gutter={5}
                title={
                  <FlexBox direction="row" fullWidth justify="between">
                    <Typography fontSize={18} fontWeight={600}>
                      Linked Content
                    </Typography>
                    {isActive && !loading ? (
                      <Typography fontSize={18} fontWeight={600} color={color.PRIMARY}>
                        ACTIVE
                      </Typography>
                    ) : (
                      <Button customSize="x-small" onClick={onMakeActive} isLoading={loading}>
                        Make Active
                      </Button>
                    )}
                  </FlexBox>
                }
              />
              <Card.Content>
                <Box margin="0 3">
                  <Typography fontSize={18}>Link Details</Typography>
                  <Typography fontSize={14} sx={{ wordBreak: 'break-all' }}>
                    URL: {attractLoop.linkedContentUrl}
                  </Typography>
                  <Box margin="6 0" />
                  <FlexBox direction="row" align="center" gutter={2}>
                    <Button
                      customSize="small"
                      width={200}
                      onClick={() => setShowDrawer(true)}
                      isLoading={loading}
                      data-testid="add-image-button"
                    >
                      Change Link
                    </Button>
                    <Button
                      customSize="small"
                      width={200}
                      appearance="white"
                      onClick={props.onDelete}
                      isLoading={loading}
                      data-testid="delete-button"
                    >
                      Delete
                    </Button>
                  </FlexBox>
                </Box>
              </Card.Content>
            </Card>
          </Box>
        </FlexBox>
      ) : (
        <Box width={650}>
          <Card raised hasBorderRadius>
            <Card.Title
              gutter={5}
              title={
                <Typography fontSize={18} fontWeight={600}>
                  Linked Content
                </Typography>
              }
            />
            <Card.Content>
              <MediaText mediaType={MediaTypes.LINKED_CONTENT} />
              <Box height={20} />
              <FlexBox fullWidth margin="3 0">
                <Box margin="0 3">
                  <Button
                    customSize="small"
                    width={200}
                    onClick={() => {
                      setShowDrawer(true);
                    }}
                    isLoading={loading}
                    data-testid="add-image-button"
                  >
                    Add Linked Content
                  </Button>
                </Box>
              </FlexBox>
            </Card.Content>
          </Card>
        </Box>
      )}
    </>
  );
};
